'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDomain = function MdDomain(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 25v3.4h-3.4v-3.4h3.4z m0-6.6v3.2h-3.4v-3.2h3.4z m3.4 13.2v-16.6h-13.4v3.4h3.4v3.2h-3.4v3.4h3.4v3.4h-3.4v3.2h13.4z m-16.8-20v-3.2h-3.2v3.2h3.2z m0 6.8v-3.4h-3.2v3.4h3.2z m0 6.6v-3.4h-3.2v3.4h3.2z m0 6.6v-3.2h-3.2v3.2h3.2z m-6.6-20v-3.2h-3.4v3.2h3.4z m0 6.8v-3.4h-3.4v3.4h3.4z m0 6.6v-3.4h-3.4v3.4h3.4z m0 6.6v-3.2h-3.4v3.2h3.4z m10-20h16.6v23.4h-33.2v-30h16.6v6.6z' })
        )
    );
};

exports.default = MdDomain;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/domain.js
// module id = 936
// module chunks = 36573943044255 79611799117203 213534597649335